import type { ReactNode } from "react";

interface Props {
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  padded?: boolean;
}

export default function Card({ title, subtitle, actions, children, className = "", padded = true }: Props) {
  return (
    <div className={`bg-white rounded-2xl border border-esm-gray-100 shadow-card ${className}`}>
      {(title || subtitle || actions) && (
        <div className={`flex items-center justify-between gap-3 ${padded ? "px-5 pt-5 pb-3" : "px-5 py-3 border-b border-esm-gray-100"}`}>
          <div className="min-w-0">
            {title && <h3 className="text-sm font-bold text-esm-gray-900">{title}</h3>}
            {subtitle && <p className="text-[11px] text-esm-gray-400 mt-0.5">{subtitle}</p>}
          </div>
          {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
        </div>
      )}
      <div className={padded ? "p-5 pt-0" : ""}>{children}</div>
    </div>
  );
}
